import { render, staticRenderFns } from "./WEBTREE.vue?vue&type=template&id=6350f3d2&scoped=true"
import script from "./WEBTREE.vue?vue&type=script&lang=js"
export * from "./WEBTREE.vue?vue&type=script&lang=js"
import style0 from "./WEBTREE.vue?vue&type=style&index=0&id=6350f3d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6350f3d2",
  null
  
)

export default component.exports